/* eslint-disable */
export default {
  notActivated: '非アクティブ',
} as const;

// @key: @#@"notActivated"@#@ @source: @#@"Inactive"@#@
